import angular from 'angular';

import NotificationModule from './notification';
import TextNotificationModule from './text-notification';
import ErrorNotificationModule from './error-notification';
import VerifyEmailNotificationModule from './verify-email-notification';
import RenewSubscriptionNotificationModule from './renew-subscription-notification';
import AlreadySubscribedNotificationModule from './already-subscribed-notification';
import EeventLimitNotificationModule from './event-limit-notification';

export default angular
    .module('application.component.notifications.component', [
        NotificationModule.name,
        TextNotificationModule.name,
        ErrorNotificationModule.name,
        VerifyEmailNotificationModule.name,
        RenewSubscriptionNotificationModule.name,
        AlreadySubscribedNotificationModule.name,
        EeventLimitNotificationModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/index.js